var map = {
	"./abb-color.svg": 1732,
	"./afb-color.svg": 1733,
	"./afb.svg": 1734,
	"./alb-color.svg": 1735,
	"./alb.svg": 1736,
	"./amb-color.svg": 1737,
	"./amb.svg": 1738,
	"./bbbaidja-color.svg": 1739,
	"./bbbaidjaxxx-color.svg": 1740,
	"./bdinidjaxxx-color.svg": 1741,
	"./bimb-color.svg": 1742,
	"./bimb.svg": 1743,
	"./bkr-color.svg": 1744,
	"./bkr.svg": 1745,
	"./bmriidja-color.svg": 1746,
	"./bniaidja-color.svg": 1747,
	"./bninidja-color.svg": 1748,
	"./bninidjaxxx-color.svg": 1749,
	"./bpay-color.svg": 1750,
	"./brinidja002-color.svg": 1751,
	"./bsmdidjaxxx-color.svg": 1752,
	"./bsn-color.svg": 1753,
	"./bsn.svg": 1754,
	"./btanidjaxxx-color.svg": 1755,
	"./cenaidja-color.svg": 1756,
	"./cenaidjaxxx-color.svg": 1757,
	"./cimb-color.svg": 1758,
	"./cimb.svg": 1759,
	"./citi-color.svg": 1760,
	"./citi.svg": 1761,
	"./default-bank-icon-color.png": 1762,
	"./default-bank-icon.png": 1763,
	"./gxbank-color.svg": 1764,
	"./hlb-color.svg": 1765,
	"./hlb.svg": 1766,
	"./hsbc-color.svg": 1767,
	"./hsbc.svg": 1768,
	"./ibbkidjaxxx-color.svg": 1769,
	"./kwh-color.svg": 1770,
	"./kwh.svg": 1771,
	"./mbb-color.svg": 1772,
	"./mbb.svg": 1773,
	"./nispidjaxxx-color.svg": 1774,
	"./ocbc-color.svg": 1775,
	"./ocbc.svg": 1776,
	"./pbb-color.svg": 1777,
	"./pbb.svg": 1778,
	"./pinbidja-color.svg": 1779,
	"./rhb-b.svg": 1780,
	"./rhb-color-b.svg": 1781,
	"./rhb-color.svg": 1782,
	"./rhb.svg": 1783,
	"./scb-color.svg": 1784,
	"./scb.svg": 1785,
	"./tng-color.svg": 1786,
	"./uob-color.svg": 1787,
	"./uob.svg": 1788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;